"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLocalePreference = void 0;
var debounce_1 = __importDefault(require("lodash/debounce"));
var gateway_client_1 = require("../generated/gateway-client");
function _setLocalePreference(gqlRequester, locale) {
    var gqlSdk = (0, gateway_client_1.getSdk)(gqlRequester);
    gqlSdk.StoreUserLocalePreference({ locale: locale }).catch(function (e) {
        console.error("Failed to cache locale preference:", e);
    });
}
/** Only supported for `{ useViewer: true }` scope */
exports.setLocalePreference = (0, debounce_1.default)(_setLocalePreference, 1000);
